"use client";

import { HStack, Icon, Tooltip } from "./index";

export function SecurityBadges() {
	return (
		<HStack className="items-center flex-wrap justify-center sm:justify-start flex gap-1">
			<Tooltip text="CASA Tier 3 represents the highest and most stringent level of security assessment in the CASA framework. It focuses on in-depth security testing, continuous monitoring, and compliance validation to ensure that a cloud application meets advanced security requirements.">
				<div className="text-text-body-muted uppercase h-10 inline-flex items-center gap-1 font-bold text-xs sm:text-xs bg-[#353535] px-2 sm:pr-3 rounded-full border-2 border-white/20">
					<Icon kind="locked" className="!size-5" />
					<div className="leading-none">
						<div>CASA Tier 3</div>
						<div>CERTIFIED</div>
					</div>
				</div>
			</Tooltip>
			<Tooltip text="California Consumer Privacy Act (CCPA) compliance means we provide California residents with transparency about data collection and the right to access, delete, and opt-out of the sale of their personal information.">
				<Icon
					kind="ccpa"
					className="!size-10 border-2 border-white/20 rounded-full"
				/>
			</Tooltip>
			<Tooltip text="General Data Protection Regulation (GDPR) compliance ensures that we handle EU citizens' personal data with strict privacy controls, giving users rights over their data including access, deletion, and portability.">
				<Icon
					kind="gdpr"
					className="!size-10 border-2 border-white/20 rounded-full"
				/>
			</Tooltip>
			{/* TODO: Show SOC2 and ISO27001 badges once we have them */}
			{/* <div className="relative">
        <Icon kind="soc2" className="!size-12" />
        <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 text-[8px] font-medium bg-white text-text-body-inverted px-[3px] py-[1px] rounded-full whitespace-nowrap">
          coming soon
        </span>
      </div>
      <div className="relative">
        <Icon kind="iso27001" className="!size-12" />
        <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 text-[8px] font-medium bg-white text-text-body-inverted px-[3px] py-[1px] rounded-full whitespace-nowrap">
          coming soon
        </span>
      </div> */}
		</HStack>
	);
}
